// extracted by css-extract-rspack-plugin
export default {"divider":"divider--OeanWFP0Lv8imYXw"};